import { isEmpty } from 'lodash4';
import { ScheduleQuery } from '../../queries/schedule_query';

export class MyScheduleCourseListController {
  private term: any;
  private courseList: any;

  constructor(private ngScheduleQuery: ScheduleQuery) {}

  getNoAvailableClassesText() {
    return isEmpty(this.ngScheduleQuery.getTermText(this.term))
      ? `Your course schedule will be available once the term starts.`
      : `You currently are not registered for any classes for ${this.ngScheduleQuery.getTermText(this.term)}.`;
  }
}

export class ScheduleCourseListComponent implements angular.IComponentOptions {
  public templateUrl: string =
    'capability-ng-course-schedule/src/components/my_schedule_course_list/my_schedule_course_list.html';
  public controller: any = MyScheduleCourseListController;
  public controllerAs: string = '$ctrl';
  public bindings: any = {
    courseList: '<',
    term: '<'
  };
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-course-schedule/src/components/my_schedule_course_list/my_schedule_course_list_controller.ts